module.exports = __webpack_public_path__ + "img/logo.437ef1b1.png";